<template>
  <NonFullPartnerRequestedOfferCardContainer
    v-bind="$attrs"
    :offer="offer"
    @display-partner-steps="onSelected"
  >
    <template #product-badge>
      <Badge type="neutral">Imóvel em garantia</Badge>
    </template>
    <template #modal>
      <component
        :is="cptdPartnerStepsModal"
        v-if="displayPartnerStepsModal"
        :display="displayPartnerStepsModal"
        @close="displayPartnerStepsModal = false"
      />
    </template>
  </NonFullPartnerRequestedOfferCardContainer>
</template>
<script>
import NonFullPartnerRequestedOfferCardContainer from '@/containers/loans/NonFullPartnerRequestedOfferCardContainer.vue'
import Badge from '@/aasgard/components/feedback/Badge.vue'
import { partnerHasFullIntegration } from '~/helpers/offers'
import { mapActions } from 'vuex'
export default {
  name: 'HomeNonFullPartnerRequestedOfferCardContainer',
  components: {
    NonFullPartnerRequestedOfferCardContainer,
    Badge,
  },
  props: {
    offer: { type: Object, required: true },
  },
  data() {
    return {
      displayPartnerStepsModal: false,
    }
  },
  computed: {
    cptdPartnersModal() {
      return []
    },
    cptdPartnerStepsModal() {
      if (this.cptdPartnersModal.includes(this.offer?.partner ?? '')) {
        return `${this.offer?.partner}_PARTNER_STEPS_BOTTOM_SHEET`
      }
      return ''
    },
  },
  methods: {
    ...mapActions({
      actSetHomeEquityOfferSelected:
        'products/loans/home-equity/home-equity/actSetHomeEquityOfferSelected',
    }),
    onSelected() {
      if (this.cptdPartnerStepsModal) {
        this.displayPartnerStepsModal = true
        return
      }
      if (this.offer) {
        const { offer_id, partner } = this.offer
        if (offer_id && partner) {
          this.actSetHomeEquityOfferSelected(this.offer)
          if (
            partnerHasFullIntegration({
              partner,
              product_type: 'home-equity',
            })
          ) {
            this.$router.push({
              path: `/contratacao/home-equity/${partner.toLowerCase()}/${offer_id}`,
            })
          } else {
            this.$router.push({
              path: `/oferta/aceita/${partner.toLowerCase()}/${offer_id}`,
            })
          }
        }
      }
    },
  },
}
</script>
<style lang="scss"></style>
